import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, " Green ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"blue"} }, " Blue ", -1)
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"blue"} }, " Blue ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { style: {"color":"green"} }, " Green ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_items = _resolveComponent("v-toolbar-items")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_breadcrumbs_item = _resolveComponent("v-breadcrumbs-item")!
  const _component_v_breadcrumbs = _resolveComponent("v-breadcrumbs")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_Notifications = _resolveComponent("Notifications")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    color: "white",
    theme: "light",
    height: "48",
    order: 2
  }, {
    default: _withCtx(() => [
      (!_ctx.navDrawerOpen)
        ? (_openBlock(), _createBlock(_component_v_toolbar_items, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                variant: "text",
                size: "small",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openNavDrawer()), ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, null, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-menu")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_breadcrumbs, {
        items: _ctx.breadcrumbs,
        class: "pl-3"
      }, _createSlots({ _: 2 }, [
        (_ctx.currentTenant !== undefined && !(_ctx.isInErrorState || _ctx.isInMaintenanceState || _ctx.isInSwitchoverState))
          ? {
              name: "item",
              fn: _withCtx((breadProps) => [
                _createVNode(_component_v_breadcrumbs_item, {
                  class: "nav-breadcrumbs",
                  to: breadProps.item.route
                }, {
                  default: _withCtx(() => [
                    (breadProps.item.selectTenant)
                      ? (_openBlock(), _createBlock(_component_v_menu, {
                          key: 0,
                          "content-class": "ben-menu",
                          offset: "15",
                          "min-width": "160",
                          "max-width": "260"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("div", _normalizeProps(_guardReactiveProps(props)), [
                              _createVNode(_component_v_btn, {
                                class: "pl-0 pr-0",
                                variant: "text"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(breadProps.item.text) + "   ", 1),
                                  _createVNode(_component_v_icon, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-menu-down")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1024)
                            ], 16)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userCustomData !== null ? _ctx.userCustomData.tenants : [], (item) => {
                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                    key: item.id,
                                    onClick: ($event: any) => (_ctx.changeTenant(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list_item_title, null, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(item.displayName), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_component_v_btn, {
                            class: "pl-0",
                            variant: "text",
                            disabled: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(breadProps.item.text), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["items"]),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_toolbar_items, null, {
        default: _withCtx(() => [
          _createVNode(_component_Notifications),
          _createVNode(_component_v_menu, {
            "content-class": "ben-menu",
            offset: "5",
            "min-width": "160",
            "max-width": "260"
          }, {
            activator: _withCtx(({ props }) => [
              _createVNode(_component_v_btn, _mergeProps({ variant: "text" }, props, { class: "pl-xs-0 pl-md-4" }), {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.fullName) + " ", 1),
                  _createVNode(_component_v_icon, { class: "pl-2" }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-account")
                    ]),
                    _: 1
                  })
                ]),
                _: 2
              }, 1040)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, { class: "py-1" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, { class: "ben-menu__item-title--small mb-1" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.fullName), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_list_item_subtitle, null, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.userCustomData !== null ? _ctx.userCustomData.email : ""), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_list_item, {
                    to: {name: 'My Account'},
                    disabled: _ctx.isInErrorState || _ctx.isInMaintenanceState
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("My Account")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openFeedbackForm()), ["stop"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Send Feedback")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_list_item, {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$store.dispatch('logOut')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [
                          _createTextVNode("Log Out")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.userCustomData?.testAccount)
                    ? (_openBlock(), _createBlock(_component_v_list_item, {
                        key: 0,
                        onClick: _ctx.toggleValidation
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(" Switch ( "),
                              (_ctx.validating)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                                    _hoisted_3,
                                    _createTextVNode(" → "),
                                    _hoisted_4
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                    _hoisted_6,
                                    _createTextVNode(" → "),
                                    _hoisted_7
                                  ])),
                              _createTextVNode(" ) ")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}